import * as yup from 'yup';

const formValidation = yup.object().shape({
  name: yup.string().required('Name is required'),
  description: yup.string(),
});

export default formValidation;
